/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1PersonIdPhotoMutationRequest,
  PostApiV1PersonIdPhotoMutationResponse,
  PostApiV1PersonIdPhotoPathParams,
  PostApiV1PersonIdPhoto400,
  PostApiV1PersonIdPhoto401,
  PostApiV1PersonIdPhoto404,
  PostApiV1PersonIdPhoto500,
} from "../../types/personRegisterController/PostApiV1PersonIdPhoto.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1PersonIdPhotoUrl(
  id: PostApiV1PersonIdPhotoPathParams["id"],
) {
  const res = { method: "POST", url: `/api/v1/person/${id}/photo` as const };
  return res;
}

/**
 * @description Faz upload da foto de perfil. Sobrescreve a foto anterior, se existir. **(Requer Authorization para autenticação)**
 * @summary Enviar foto de perfil (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/photo}
 */
export async function postApiV1PersonIdPhoto(
  id: PostApiV1PersonIdPhotoPathParams["id"],
  data?: PostApiV1PersonIdPhotoMutationRequest,
  config: Partial<RequestConfig<PostApiV1PersonIdPhotoMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1PersonIdPhotoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdPhoto400
      | PostApiV1PersonIdPhoto401
      | PostApiV1PersonIdPhoto404
      | PostApiV1PersonIdPhoto500
    >,
    PostApiV1PersonIdPhotoMutationRequest
  >({
    method: "POST",
    url: getPostApiV1PersonIdPhotoUrl(id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
